// import windows from '../main'

// export function rightButtonShow() {
//   let VOSList = windows.globalVue.$store.state.user.userData.resourceVOS
//   console.log(VOSList)
//   let VOSID = VOSList.filter(
//     item => item.displayName === windows.globalVue.$route.meta.title
//   )
//   let buttons = []
//   if (VOSID.length === 0) {
//     sessionStorage.removeItem('btnContext')
//     return
//   }
//   VOSID = VOSID.filter(el => el.name.length <= 6)
//   buttons = VOSList.filter(item => item.parentId === VOSID[0].id)
//   let arr = []
//   if (buttons.length > 0) {
//     buttons.forEach(item => {
//       arr.push(item.name.split('_')[1])
//     })
//   }

//   if (arr.length > 0) {
//     sessionStorage.setItem('btnContext', JSON.stringify(arr))
//   }
//   // return arr
// }

export function authButton(Vue) {
  Vue.directive('has', {
    inserted: function(el, binding) {
      let auth = []
      if (localStorage.getItem('btnList') != null) {
        auth = localStorage.getItem('btnList') || []
      } else {
        // el.parentNode.removeChild(el)
        return
      }
      if (JSON.stringify(binding.arg) !== undefined) {
        binding.value = binding.arg
        console.log(binding.arg)
      }

      auth = JSON.parse(auth)
      let show = false
      auth.forEach(item => {
        if (item === binding.value) {
          show = true
        }
      })
      if (!show) {
        el.parentNode.removeChild(el)
      }
    }
  })
}

// 防止按钮重复点击1000ms内，也可以自设时间
export function resubmitNotButton(Vue) {
  Vue.directive('noresub', {
    inserted(el, binding) {
      const pointDoms = [] // 使用这个指令的所有DOM对象
      pointDoms.push(el) // 存储使用这个指令的DOM
      el.addEventListener('click', () => {
        // 禁用所有使用这个指令的DOM结构点击事件
        if (!el.disabled) {
          el.disabled = true
          setTimeout(() => {
            el.disabled = false
          }, binding.value || 2000)
        }
      })
      el.unbindEventListener = () => {
        el.disabled = true
      }
    },
    unbind(el) {
      // 阻止内存泄漏
      if (el.unbindEventListener) {
        el.unbindEventListener()
      }
    }
  })
}
